<script setup lang="ts">
import { TAB_BAR_LIST } from "@/config";
import { useAppStore } from "@/store";
import { storeToRefs } from "pinia";
import CopyRight from "@/components/CopyRight/index.vue";
import { wxInit } from "@/utils/wx";

const appStore = useAppStore();
const { showTabBar, tabBarActive } = storeToRefs(appStore);
wxInit();
</script>

<template>
  <div class="container">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
  <div class="empty" v-if="tabBarActive !== 1"></div>
  <copy-right />
  <van-tabbar
    v-if="showTabBar"
    v-model="tabBarActive"
    @change="appStore.setTabActive"
  >
    <van-tabbar-item
      v-for="(item, index) in TAB_BAR_LIST"
      :inactive-color="item.color"
      :active-color="item.activeColor"
      :icon="`${tabBarActive === index ? item.activeImage : item.image}`"
      :url="item.url"
    >
      {{ item.text }}
    </van-tabbar-item>
  </van-tabbar>
</template>

<style lang="less" scoped>
.empty {
  height: 100px;
}
</style>
